"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tag_service_1 = require("./modules/tag/tag.service");
const user_service_1 = require("./modules/user/user.service");
class LastFm {
    constructor(API_KEY) {
        if (!API_KEY) {
            throw new Error("API key has not set");
        }
        this.API_KEY = API_KEY;
        this.user = new user_service_1.User(this.API_KEY);
        this.tag = new tag_service_1.Tag(this.API_KEY);
    }
}
exports.default = LastFm;
//# sourceMappingURL=lastfm.js.map